module.exports = __webpack_public_path__ + "static/media/16Cremebrule.4b3f79b5.png";